import script from "./CheckboxListButton.vue?vue&type=script&lang=ts&setup=true&generic=DataType"
export * from "./CheckboxListButton.vue?vue&type=script&lang=ts&setup=true&generic=DataType"

import "./CheckboxListButton.vue?vue&type=style&index=0&id=6736df6a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6736df6a"]])

export default __exports__